import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import config from "../package.json";
import MarketIndices from "./Pages/MarketIndices";
import Newswidget from "./Pages/Newswidget";
import Ownership from "./Pages/Ownership";
import ConsensusRecommendation from "./Pages/ConsensusRecommendation";
import CompanyProfile from "./Pages/CompanyProfile";
import FullNewswidget from "./Pages/FullNewswidget";
import IframeTestPage from "./Pages/IframeTestPage";
import TopMovers from "./Pages/TopMovers";
import SectorPeerComparison from "./Pages/SectorPeerComparison";
import StockPeerComparison from "./Pages/StockPeerComparison";
import SectorAnalysis from "./Pages/SectorAnalysis";
import SectorIndices from "./Pages/SectorIndices";
import SectorHeatmap from "./Pages/SectorHeatmap";
import SectorAnalysis2 from "./Pages/SectorAnalysis2";
import SectorAnalysis1 from "./Pages/SectorAnalysis1";
import SectorAnalysisIframe from "./Pages/SectorAnalysisIframe";
import SectorAnalysisIframe1 from "./Pages/SectorAnalysisIframe1";
import SectorAnalysisIframe2 from "./Pages/SectorAnalysisIframe2";
import Screenerwidget from "./Pages/Screenerwidget";
import FundScreener from "./Pages/FundScreener";
import TestLinks from "./Pages/TestLinks";
import PriceHistory from "./Pages/PriceHistory";
import Indices from "./Pages/Indices";
import IndicesPeerComparison from "./Pages/IndicesPeerComparison";
import MiniChart from "./Pages/MiniChart";
import DevPage from "./Pages/DevPage";
import BrokerRating from "./Pages/BrokerRating";
import TargetPrice from "./Pages/TargetPrice";
import CompanyScore from "./Pages/CompanyScore";
import IncomeStatement from "./Pages/IncomeStatement";
import BalanceSheet from "./Pages/BalanceSheet";
import CashFlow from "./Pages/CashFlow";
import KeyRatios from "./Pages/KeyRatios";
import CompanyEvent from "./Pages/CompanyEvent";
import CompanyDirector from "./Pages/CompanyDirector";
import DividendHistory from "./Pages/DividendHistory";
import Sentiment from "./Pages/Sentiment";
import AdvanceChart from "./Pages/AdvanceChart";
import IndexChart from "./Pages/IndexChart";
import FundSummary from "./Pages/FundSummary";
const HeatmapPage = lazy(() => import("./Pages/Heatmap"));
const DashboardPage = lazy(() => import("./Pages/DashboardPage"));
const DemoDashboard = lazy(() => import("./Pages/DemoDashboard"));

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ""}>
        <Routes>
          <Route
            path="/mktindices"
            element={
              <Suspense fallback={<></>}>
                <MarketIndices />
              </Suspense>
            }
          />
          <Route
            path="/minichart"
            element={
              <Suspense fallback={<></>}>
                <MiniChart />
              </Suspense>
            }
          />
          <Route
            path="/news"
            element={
              <Suspense fallback={<></>}>
                <Newswidget />
              </Suspense>
            }
          />
          <Route
            path="/heatmap"
            element={
              <Suspense fallback={<></>}>
                <HeatmapPage />
              </Suspense>
            }
          />
          <Route
            path="/ownership"
            element={
              <Suspense fallback={<></>}>
                <Ownership />
              </Suspense>
            }
          />
          <Route
            path="/consensusrecommendation"
            element={
              <Suspense fallback={<></>}>
                <ConsensusRecommendation />
              </Suspense>
            }
          />
          <Route
            path="/companyprofile"
            element={
              <Suspense fallback={<></>}>
                <CompanyProfile />
              </Suspense>
            }
          />
          <Route
            path="/fullnews"
            element={
              <Suspense fallback={<></>}>
                <FullNewswidget />
              </Suspense>
            }
          />
          <Route
            path="/topmovers"
            element={
              <Suspense fallback={<></>}>
                <TopMovers />
              </Suspense>
            }
          />
          <Route
            path="/sectorpeercomparison"
            element={
              <Suspense fallback={<></>}>
                <SectorPeerComparison />
              </Suspense>
            }
          />
          <Route
            path="/stockpeercomparison"
            element={
              <Suspense fallback={<></>}>
                <StockPeerComparison />
              </Suspense>
            }
          />
          <Route
            path="/sectorindices"
            element={
              <Suspense fallback={<></>}>
                <SectorIndices />
              </Suspense>
            }
          />
          <Route
            path="/sectorheatmap"
            element={
              <Suspense fallback={<></>}>
                <SectorHeatmap />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysis"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysis />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysis1"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysis1 />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysis2"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysis2 />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysisiframe"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysisIframe />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysisiframe1"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysisIframe1 />
              </Suspense>
            }
          />
          <Route
            path="/sectoranalysisiframe2"
            element={
              <Suspense fallback={<></>}>
                <SectorAnalysisIframe2 />
              </Suspense>
            }
          />
          <Route
            path="/screener"
            element={
              <Suspense fallback={<></>}>
                <Screenerwidget />
              </Suspense>
            }
          />
          <Route
            path="/fundscreener"
            element={
              <Suspense fallback={<></>}>
                <FundScreener />
              </Suspense>
            }
          />
          <Route
            path="/pricehistory"
            element={
              <Suspense fallback={<></>}>
                <PriceHistory />
              </Suspense>
            }
          />
          <Route
            path="/indices"
            element={
              <Suspense fallback={<></>}>
                <Indices />
              </Suspense>
            }
          />
          <Route
            path="/indicespeercomparison"
            element={
              <Suspense fallback={<></>}>
                <IndicesPeerComparison />
              </Suspense>
            }
          />
          <Route
            path="/brokerrating"
            element={
              <Suspense fallback={<></>}>
                <BrokerRating />
              </Suspense>
            }
          />
          <Route
            path="/targetprice"
            element={
              <Suspense fallback={<></>}>
                <TargetPrice />
              </Suspense>
            }
          />
          <Route
            path="/companyscore"
            element={
              <Suspense fallback={<></>}>
                <CompanyScore />
              </Suspense>
            }
          />
          <Route
            path="/incomestatement"
            element={
              <Suspense fallback={<></>}>
                <IncomeStatement />
              </Suspense>
            }
          />
          <Route
            path="/balancesheet"
            element={
              <Suspense fallback={<></>}>
                <BalanceSheet />
              </Suspense>
            }
          />
          <Route
            path="/cashflow"
            element={
              <Suspense fallback={<></>}>
                <CashFlow />
              </Suspense>
            }
          />
          <Route
            path="/keyratios"
            element={
              <Suspense fallback={<></>}>
                <KeyRatios />
              </Suspense>
            }
          />
          <Route
            path="/companyevent"
            element={
              <Suspense fallback={<></>}>
                <CompanyEvent />
              </Suspense>
            }
          />
          <Route
            path="/companydirector"
            element={
              <Suspense fallback={<></>}>
                <CompanyDirector />
              </Suspense>
            }
          />
          <Route
            path="/dividendhistory"
            element={
              <Suspense fallback={<></>}>
                <DividendHistory />
              </Suspense>
            }
          />
          <Route
            path="/sentiment"
            element={
              <Suspense fallback={<></>}>
                <Sentiment />
              </Suspense>
            }
          />
          <Route
            path="/advancechart"
            element={
              <Suspense fallback={<></>}>
                <AdvanceChart />
              </Suspense>
            }
          />
          <Route
            path="/indexchart"
            element={
              <Suspense fallback={<></>}>
                <IndexChart />
              </Suspense>
            }
          />
          <Route
            path="/fundsummary"
            element={
              <Suspense fallback={<></>}>
                <FundSummary />
              </Suspense>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Suspense fallback={<></>}>
                <DashboardPage />
              </Suspense>
            }
          />
          <Route
            path="/demo_dashboard"
            element={
              <Suspense fallback={<></>}>
                <DemoDashboard />
              </Suspense>
            }
          />
          <Route
            path="/iframe"
            element={
              <Suspense fallback={<></>}>
                <IframeTestPage />
              </Suspense>
            }
          />
          <Route
            path="ui/error"
            element={
              <Suspense fallback={<></>}>
                <div>Error Page</div>
              </Suspense>
            }
          />
          <Route
            path="/version"
            element={
              <Suspense fallback={<></>}>
                <div style={{ textAlign: "left" }}>
                  v{config.version + "." + config.version2}
                </div>
              </Suspense>
            }
          />
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <TestLinks />
              </Suspense>
            }
          />
          <Route
            path="/devpage"
            element={
              <Suspense fallback={<></>}>
                <DevPage />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
